module.exports = __webpack_public_path__ + "assets/30dfa87de82e7d125c1baca42b7d6c53.png";